import { Box, styled, Typography } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

const Heading3 = withDefaultProps(Typography, { variant: "h3" });
export const StyledTitle = styled(Heading3)(({ theme }) => ({
  paddingBottom: theme.spacing(1.5),
}));

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.biarri.secondary.grey,
  paddingBottom: theme.spacing(1.5),
}));

export const StyledText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.size.small,
  paddingBottom: theme.spacing(1.5),
}));

const SubTitle2 = withDefaultProps(Typography, { variant: "subtitle2" });
export const GreyText = styled(SubTitle2)(({ theme }) => ({
  color: theme.palette.biarri.secondary.grey,
}));

export const DarkGreyText = styled(StyledText)(({ theme }) => ({
  color: theme.palette.biarri.primary.darkGrey,
}));

export const RowContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
});
